import React, { useState } from "react";
import { api } from "../api";
import { Link } from "react-router-dom";
export default function Login({ onLogin, sessionExpired }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await api.login(email, password);
      onLogin(user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <form onSubmit={submit} className="bg-white shadow-md rounded-lg p-8 w-full max-w-sm">
        <img src="/logo.png" alt="Jybek Homecare Services" className="h-16 w-auto mx-auto mb-4" />
        <h1 className="text-xl font-bold mb-1 text-center" style={{ color: "#154E93" }}>
          JyBek Home Care Services
        </h1>
        <p className="text-sm text-gray-500 mb-6 text-center">Sign in to continue your training</p>
        {sessionExpired && !error && (
          <div className="mb-4 text-sm bg-blue-50 text-blue-700 px-3 py-2 rounded">
            Your session expired. Please log in again.
          </div>
        )}
        {error && (
          <div className="mb-4 text-sm bg-red-50 text-red-700 px-3 py-2 rounded">{error}</div>
        )}
        <label className="block text-sm font-medium mb-1">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4 text-sm"
        />
        <label className="block text-sm font-medium mb-1">Password</label>
        <div className="relative mb-6">
          <input
            type={showPassword ? "text" : "password"}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border rounded px-3 py-2 pr-16 text-sm"
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-gray-500 hover:text-gray-700"
            tabIndex={-1}
          >
            {showPassword ? "Hide" : "Show"}
          </button>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full text-white font-medium py-2 rounded"
          style={{ backgroundColor: "#154E93" }}
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <Link
          to="/forgot-password"
          className="block w-full text-center text-xs text-gray-500 hover:text-gray-700 mt-4 underline"
        >
          Forgot your password?
        </Link>
      </form>
    </div>
  );
}
